export const isPrerenderAgent = () => {
  return window.navigator.userAgent.includes('Prerender') || window.navigator.userAgent.includes('prerender');
};